import { render, staticRenderFns } from "./SpecimenIncidencesModal.vue?vue&type=template&id=39a50d3e&scoped=true"
import script from "./SpecimenIncidencesModal.vue?vue&type=script&lang=js"
export * from "./SpecimenIncidencesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a50d3e",
  null
  
)

export default component.exports